import React from 'react';
import PropTypes from 'prop-types';

const Field = ({ children }) => (
  <div className="form-field">
    {children}
  </div>
);

Field.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Field;
